import React, { useState } from 'react';
import { AccordionItem } from './Accordion';
export function Bonos() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const bonos = [{
    num: '01',
    icon: '🖼️',
    title: 'Póster de Acordes Imprimible',
    price: '$8.000',
    desc: 'Los acordes esenciales en una sola lámina para tener siempre a mano.',
    sirve: 'Para no tener que abrir el tomo cada vez que te olvidás un acorde. Lo imprimís y lo dejás al lado de donde practicás.'
  }, {
    num: '02',
    icon: '📅',
    title: 'Plan de Práctica de 30 Días',
    price: '$7.000',
    desc: 'La rutina diaria que convierte el aprendizaje en hábito.',
    sirve: 'Para que no dependas de la motivación del día. Son 15-20 minutos diarios con una estructura clara que te hace avanzar aunque estés cansado.'
  }, {
    num: '03',
    icon: '🎶',
    title: 'Cancionero de Práctica Fácil',
    price: '$9.000',
    desc: 'Canciones extra simplificadas para seguir practicando más allá del Tomo 4.',
    sirve: 'Para que nunca te quedes sin material nuevo para practicar mientras avanzás con el método.'
  }, {
    num: '04',
    icon: '🔧',
    title: 'Guía de Afinación y Cuidado',
    price: '$8.000',
    desc: 'Cómo mantener tu guitarra afinada y en buen estado, paso a paso.',
    sirve: 'Para que tu instrumento no sea un obstáculo. Cuerdas, humedad, afinación y mantenimiento básico explicado simple.'
  }];
  return <section className="w-full bg-badges-dorado text-fondo-principal py-section px-4" data-id="element-23">
      <div className="text-center mb-8" data-id="element-24">
        <h2 className="text-2xl font-bold mb-2" data-id="element-25">
          4 bonos incluidos. Gratis. Siempre.
        </h2>
        <p className="font-medium" data-id="element-26">
          Valor total:{' '}
          <span className="line-through opacity-70" data-id="element-27">$32.000 ARS</span> → $0 con
          tu sistema.
        </p>
      </div>

      <div className="flex flex-col gap-3" data-id="element-28">
        {bonos.map((bono, idx) => <AccordionItem key={idx} variant="golden" isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)} title={<div className="flex flex-col gap-1" data-id="element-30">
                <div className="flex items-center gap-2 text-sm font-bold text-gray-500" data-id="element-31">
                  <span data-id="element-32">BONO {bono.num}</span>
                  <span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs line-through" data-id="element-33">
                    {bono.price}
                  </span>
                  <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs" data-id="element-34">
                    GRATIS
                  </span>
                </div>
                <div className="flex items-center gap-2 font-bold text-base" data-id="element-35">
                  <span data-id="element-36">{bono.icon}</span>
                  <span data-id="element-37">{bono.title}</span>
                </div>
              </div>} content={<div className="pt-2 text-sm" data-id="element-38">
                <p className="font-medium mb-3" data-id="element-39">{bono.desc}</p>
                <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200" data-id="element-40">
                  <span className="font-bold block mb-1" data-id="element-41">Para qué sirve:</span>
                  <span className="text-gray-700" data-id="element-42">{bono.sirve}</span>
                </div>
              </div>} data-id="element-29" />)}
      </div>
    </section>;
}